export const mexicanSpanishValidationMessage = {
    /**
     * Gives the validation message for the required fields
     * @param {string} fieldName
     */
    forRequiredField(fieldName) {
        // Transforming the entire message to the upper case as per the UX, can be changed later
        return `${fieldName} No puede ir vacío`.toUpperCase()
    },

    forAlphabeticOnly() {
        return "Solo Alfabético".toUpperCase()
    },

    forAlphanumericOnly() {
        return "Solo Alfanumérico".toUpperCase()
    },

    forAlphanumericAndSpacesOnly() {
        return "Solo Alfanumérico y Espacios".toUpperCase()
    },

    forNumericOnly() {
        return "Solo valores numéricos".toUpperCase()
    },

    forPositiveNumber(fieldName) {
        return `${fieldName} debe ser mayor que 0`.toUpperCase()
    },

    forMaxDecimalPlaces(fieldName, places) {
        return `${fieldName} puede tener hasta ${places} decimales`.toUpperCase()
    },

    forDuplicateField(fieldName) {
        return `${fieldName} Ya existe`.toUpperCase()
    },

    forEmailAddress() {
        return `Ingrese un email válido`.toUpperCase()
    },

    forInvalidFormat(fieldName, type, format) {
        return `Formato inválido ${fieldName}${
            format ? `. Formato  ${format} esperado ${type}` : ""
        }`.toUpperCase()
    },

    forStartDateBeforeEndDate() {
        return "La fecha de inicio debe ser anterior o igual a la fecha de fin".toUpperCase()
    },

    forDatesInFuture() {
        return "Las fechas deben ser hoy o en el futuro".toUpperCase()
    },

    forConfirmingCancel(
        selectedAction,
        selectedCars,
        failedCars,
        shipmentData
    ) {
        return `Esta solicitando Cancelar ${selectedAction} ${"("}${
            failedCars.length ? failedCars.length : selectedCars.length
        }${")"}${shipmentData.length} Carros. Confirmar la Operación?`
    },

    forConfirmingAction(
        selectedAction,
        selectedCars,
        failedCars,
        shipmentData
    ) {
        return `Esta solicitando ${selectedAction} ${"("}${
            failedCars.length ? failedCars.length : selectedCars.length
        }${")"}${shipmentData.length} Carros. Confirmar la Operación?`
    },

    forUnableToProcessAction(selectedAction, selectedCars, temparray) {
        return `${selectedAction} no se pudo procesar la solicitud ${temparray.length} de ${selectedCars.length}, consulte los resultados del proceso.`
    },

    forPlacedAction(selectedAction, selectedCars) {
        return `${selectedAction} solicitud de ${selectedCars.length} Equipo ha sido Situado.`
    },

    forActionInProcess() {
        return `Por favor espere mientras se procesa su solicitud.`
    },

    forPlanDeleted(deletePlanName) {
        return `Plan "${deletePlanName}" ha sido eliminado.`
    },

    forSelectingCarSpecifics(selectedCar) {
        return `Seleccione ${selectedCar} especificación de carro`
    },

    invalidNumber: "Este es un Número Inválido",
    invalidCharacter: "Este es un Caracter Inválido",
    unableToProcess: "No se puede procesar la solicitud.",
}
